import Link from 'next/link'
import { withI18next } from '../../../lib/withI18next'


const HeaderNavigation = ({ t }) => (
  <div className="navbar-start">
    <Link href="/electronic-service"><a className="navbar-item">
      <span>{t('common:navigation_menu-item-esi')}</span>
    </a></Link>
    <Link href="/training-information"><a className="navbar-item">
      <span>        
        {t('common:navigation_menu-item-training-1')}<br />{t('common:navigation_menu-item-training-2')}
      </span>
    </a></Link>
    <Link href="/vcm-diagnostic"><a className="navbar-item">
      <span>
        {t('common:navigation_menu-item-vcm-1')}<br />{t('common:navigation_menu-item-vcm-2')}
      </span>
    </a></Link>
    <Link href="/pcm-reflashing"><a className="navbar-item">
      <span>
        {t('common:navigation_menu-item-pcm-1')}<br />{t('common:navigation_menu-item-pcm-2')}
      </span>
    </a></Link>    
    <Link href="/ids-software"><a className="navbar-item">
      <span>
        {t('common:navigation_menu-item-ids-1')}<br />{t('common:navigation_menu-item-ids-2')}
      </span>
    </a></Link>
    <Link href="/mdars-software"><a className="navbar-item">
      <span>
        {t('common:navigation_menu-item-mdars-1')}<br />{t('common:navigation_menu-item-mdars-2')}
      </span>
    </a></Link>    
    <Link href="/pats-codes"><a className="navbar-item">
      <span>
        {t('common:navigation_menu-item-pats-1')}<br />{t('common:navigation_menu-item-pats-2')}
      </span>
    </a></Link>
  </div>
)

export default withI18next(['common'])(HeaderNavigation)



// WEBPACK FOOTER //
// ./components/Header/HeaderNavigation/index.js